


























































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import BaseView from '~/components/BaseView';

@Component<InformationModal>({
    components: {},
    icons: {
        faTimes,
    },
})
export default class InformationModal extends BaseView {
    @Prop()
    isShowDialogue!: boolean;
    @Prop()
    title!: string;

    handleClose() {
        this.$emit('close');
    }
}
